<mat-toolbar class="shell-topbar">

  <!-- Burger moved to sidebar - hidden from topbar -->
  <!-- Logo only appears on topbar when not needed in sidebar -->
  <a [routerLink]="['/dashboard']" class="topbar-logo-link" aria-label="Go to dashboard">
    <img src="../../../../assets/images/logo.png" class="topbar-logo" alt="Logo">
  </a>

  <span class="topbar-spacer"></span>

  <span class="topbar-spacer"></span>

  <!-- Notification bell -->
  <button mat-icon-button [routerLink]="['/notifications']" aria-label="Notifications">
    <mat-icon [matBadge]="unreadCount" [matBadgeHidden]="unreadCount === 0" matBadgeColor="warn"
      matBadgeSize="medium">notifications_none</mat-icon>
  </button>

  <!-- User menu — avatar only, name lives inside the dropdown -->
  <button mat-icon-button [matMenuTriggerFor]="userMenu" class="topbar-avatar-btn" *ngIf="currentUser"
    [attr.aria-label]="getUserDisplayName()">
    <div class="user-avatar">{{ getUserInitials() }}</div>
  </button>

  <mat-menu #userMenu="matMenu" xPosition="before">
    <div class="user-menu-header" (click)="$event.stopPropagation()">
      <strong>{{ currentUser?.name }}</strong>
      <small>{{ currentUser?.loginId }}</small>
      <small *ngIf="currentUser?.roles?.length">{{ currentUser?.roles?.[0] | titlecase }}</small>
    </div>
    <mat-divider></mat-divider>
    <button mat-menu-item (click)="goToProfile()">
      <mat-icon>person_outline</mat-icon> Profile
    </button>
    <button mat-menu-item (click)="logout()">
      <mat-icon>logout</mat-icon> Logout
    </button>
  </mat-menu>

  <!-- Fallback -->
  <button mat-flat-button color="primary" routerLink="/login" *ngIf="!currentUser">Login</button>

</mat-toolbar>